export enum Countries {
  Belgium = 'Belgium',
  Canada = 'Canada',
  France = 'France',
  UnitedStates = 'United States',
  UnitedKingdom = 'United Kingdom',
}

// map country names to their respective ISO 3166-1 alpha-2
export enum CountriesIsoCode {
  Belgium = 'BE',
  Canada = 'CA',
  France = 'FR',
  'United States' = 'US',
  'United Kingdom' = 'GB',
}

// reverse map ISO 3166-1 alpha-2 codes to country names
export enum IsoCodeCountries {
  BE = Countries.Belgium,
  CA = Countries.Canada,
  FR = Countries.France,
  US = Countries.UnitedStates,
  GB = Countries.UnitedKingdom,
}
